import { render, staticRenderFns } from "./PromotionUser.vue?vue&type=template&id=a96eae4e&scoped=true"
import script from "./PromotionUser.vue?vue&type=script&lang=js"
export * from "./PromotionUser.vue?vue&type=script&lang=js"
import style0 from "./PromotionUser.vue?vue&type=style&index=0&id=a96eae4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96eae4e",
  null
  
)

export default component.exports